module.exports = __webpack_public_path__ + "static/media/plate.c8331da0.png";